import { render, staticRenderFns } from "./Stats.container.vue?vue&type=template&id=794b7a86&scoped=true&"
import script from "./Stats.container.vue?vue&type=script&lang=js&"
export * from "./Stats.container.vue?vue&type=script&lang=js&"
import style0 from "./Stats.container.vue?vue&type=style&index=0&id=794b7a86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794b7a86",
  null
  
)

export default component.exports